import React, { useEffect, useState } from "react";
import LcIconLink from "../../Generic/LcIconLink";
import "./index.css";
import GenerativeIaEvaluationService from "../../../services/GenerativeIaEvaluationService/GenerativeIaEvaluationService";
import LcLoading from "../LcLoading";
import AlertNotification, { AlertColor } from "../../Dialog/AlertNotification";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

interface Props {
    title?: string,
    originalText: string,
    close: Function,
    visible: boolean,
    width?: string
    height?: string
    handleVisible: Function
    setText: Function
    user: any
    solicitation: any
    conclusion?: Boolean
    position?: any
}

const HHCommentAI: React.FC<Props> = (props) => {
    const generativeIaEvaluationService = new GenerativeIaEvaluationService(props);
    const [suggestion, setSuggestion] = React.useState<string>("");
    const [loadingSugggestion, setLoadingSugggestion] = React.useState<boolean>(false);
    const [totalTokens, setTotalTokens] = React.useState<number>(0);
    const [severity, setSeverity] = useState<AlertColor>("info");
    const [message, setMessage] = useState<string>("");
    const [openNotificacao, setOpenNotificacao] = useState<boolean>(false);

    useEffect(() => {
        if (props.visible) {
            getSugestion();
        }
    }, [props.visible]);

    const getSugestion = async () => {
        setLoadingSugggestion(true);

        try {
            const requestObj = {
                IdSolicitation: props.solicitation.id,
                IdUser: props.user.id,
                Prompt: props.originalText
            }

            const response = (props.conclusion) ? await generativeIaEvaluationService.GetExpandedSuggestionConclusion(requestObj) : await generativeIaEvaluationService.GetExpandedSuggestion(requestObj);
            var content = response.data.responseOpenAI.choices[0].message.content;
            setTotalTokens(response.data.responseOpenAI.usage.total_tokens);

            // parece maluquice, mas é necessário para quebrar a linha
            var textString = JSON.stringify(content).replaceAll("\\n", "<br>");
            var _text = JSON.parse(textString);

            setSuggestion(_text);
        }
        catch (error) {
            console.log(error);
            debugger
        }

        setLoadingSugggestion(false);
    }

    const copyToClipbord = () => {
        var textString = JSON
            .stringify(suggestion)
            .replaceAll("<br>", "\\n")
            .replaceAll("<br />", "\\n")
            .replaceAll("<br/>", "\\n");
        var _text = JSON.parse(textString);
        navigator.clipboard.writeText(_text);
        setMessage(`Texto copiado com sucesso`);
        setSeverity("success");
        setOpenNotificacao(true);
        setTimeout(() => setOpenNotificacao(false), 2000);
    };

    const handleClickAway = () => {
        if (props.visible && props.handleVisible) {
            props.handleVisible(false);
        }
    };

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <div className={"ai-modal"}>
                <AlertNotification open={openNotificacao} severity={severity} message={message} handleClose={() => setOpenNotificacao(false)} />
                {
                    props.visible &&
                    <div
                        className={"all"}
                        style={{
                            right: (props.position && props.position.right) ? props.position.right : undefined,
                            bottom: (props.position && props.position.bottom) ? props.position.bottom : undefined,
                        }}>
                        <div className={"content"}>
                            {/* <div className="header">
                            {
                                props.title &&
                                <div className="title">{props.title}</div>
                            }
                            <LcIconLink icon="ppi ppi-x" tooltip="Fechar" onClick={() => props.close(false)} />
                        </div> */}

                            <div className="body">
                                <>
                                    <div className={"title-originalText"}>
                                        <span>Texto Original</span>
                                        <LcIconLink icon="ppi ppi-x" tooltip="Fechar" onClick={() => props.close(false)} />
                                    </div>
                                    {/* <textarea disabled className="originalText" name="originalText" id="originalText" style={{ width: "450px", height: "100px" }}></textarea> */}
                                    <div className={"originalText disabled"} id="originalText" dangerouslySetInnerHTML={{ __html: props.originalText }} />
                                </>
                                <>
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        <div className={"title-sugestao"}>
                                            <span style={{ marginRight: "5px" }}>Sugestão expandida</span>
                                            <LcIconLink icon={"ppi ppi-refresh"} tooltip={"Nova sugestão"} onClick={() => getSugestion()} />
                                        </div>

                                        {/* {
                                        !loadingSugggestion && totalTokens > 0 &&
                                        <span style={{ marginLeft: "5px" }}>Total de tokens usados: {totalTokens}</span>
                                    } */}
                                    </div>

                                    <LcLoading label={"Carregando..."} loading={loadingSugggestion} height={"15vh"} width={"450px"}>
                                        {/* <textarea disabled className="AiText" name="AiText" id="AiText" style={{ width: "450px", height: "150px" }}>{suggestion}</textarea> */}
                                        <div className={"AiText disabled"} id="AiText" dangerouslySetInnerHTML={{ __html: suggestion }} />
                                    </LcLoading>
                                </>
                                <div className="btn-wrapper">
                                    <LcIconLink icon="ppi ppi-duplicate" tooltip={"Copiar"} onClick={() => copyToClipbord()} />
                                    <div>
                                        <button className={"lc-button bg-info small ia-button"} onClick={() => props.handleVisible(false)} style={{ marginRight: "5px" }}>Ignorar</button>
                                        <button className={"lc-button bg-info small ia-button"} onClick={() => { props.setText(suggestion); }}>Substituir</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </ClickAwayListener>
    );
}

export default HHCommentAI;